// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PwUR5","type":"styles_type__o3Rv5","choices":"styles_choices__1mm5l"};